module.exports = __webpack_public_path__ + "static/img/son2_active.2fdf1550.png";